import { withProps } from 'recompose';
import { Switch } from '@material-ui/core';
import CheckContainer from './check_container';

export default withProps(() => ({ component: Switch }))(CheckContainer);
